import { Box, Button, Center, Divider, ModalBody, ModalFooter, ModalHeader } from '@chakra-ui/react';
import { QRCodeCanvas } from 'qrcode.react';
import { BaseModal } from './BaseModal';
import MaskImage from '../../assets/img/WhiteMaskBg.png';
import { RippleBackBtn } from '../Buttons/RippleBackBtn';
import { BiShareAlt } from 'react-icons/bi';
import { useTranslation } from 'react-i18next';
import { RefObject, useRef } from 'react';
import { useToast } from '../../hooks';

interface IMemberQrCode {
  isOpen: boolean;
  onClose: VoidFunction;
  code: string;
  firstName: string;
  lastName: string;
}

export const MemberQrCodeModal = (props: IMemberQrCode) => {
  const { t } = useTranslation();
  const { firstName, lastName, code, isOpen, onClose } = props;
  const { showToast } = useToast();
  const isCanShare: boolean = !!navigator?.share;
  const canvasWrapperRef: RefObject<HTMLDivElement> = useRef(null);

  const onShare = async () => {
    const canvas = canvasWrapperRef?.current?.children[0] as HTMLCanvasElement;
    if (canvas) {
      const blob: Blob | null = await new Promise((resolve) => canvas.toBlob((blob) => resolve(blob), 'image/png'));
      const file = blob && new File([blob], `QRCode.png`, { type: blob.type });
      const shareData = { files: file ? [file] : [] };

      if (navigator.canShare(shareData)) {
        try {
          await navigator.share(shareData);
        } catch (err: any) {
          if (err.name !== 'AbortError') {
            showToast({ type: 'error', message: err?.message });
          }
        }
      }
    }
  };

  return (
    <BaseModal
      isOpen={isOpen}
      size='full'
      contentProps={{
        sx: {
          background: `url(${MaskImage}) bottom right no-repeat, #fff`,
          overflow: 'auto',
        },
      }}
    >
      <ModalHeader
        fontSize={{ base: '5xl', lg: '6xl' }}
        fontWeight={400}
        fontStyle='italic'
        mt={{ base: '0', lg: '5vh' }}
      >{`${firstName} ${lastName}`}</ModalHeader>

      <ModalBody>
        <Center flexDirection='column' mt='3vh'>
          <div ref={canvasWrapperRef}>
            <QRCodeCanvas value={code} size={300} />
          </div>

          {isCanShare ? (
            <Button
              variant='unstyled'
              color='brand.cyan'
              leftIcon={<BiShareAlt />}
              px={0}
              py={1}
              h='initial'
              mt='5vh'
              onClick={onShare}
            >
              {t('member.share.qr.btn')}
              <Divider sx={{ position: 'absolute', bottom: 0, borderColor: 'brand.cyan' }} />
            </Button>
          ) : null}
        </Center>
      </ModalBody>

      <ModalFooter>
        <Box h={{ base: 50, lg: 55 }}>
          <RippleBackBtn onClick={onClose} width='100%' />
        </Box>
      </ModalFooter>
    </BaseModal>
  );
};
